import type { ContractShapeOf, RequestHandlers } from 'shared/channels';
import type { inspectionTemplateContract } from 'shared/domain/inspectionTemplate/inspectionTemplateContract';
import { inspectionTemplateCreator } from './createInspectionTemplate';
import { inspectionTemplateChecklistItemsCreator } from './createInspectionTemplateChecklistItems';
import { inspectionTemplateEditor } from './editInspectionTemplate';
import { inspectionTemplateChecklistItemEditor } from './editInspectionTemplateChecklistItem';
import { inspectionTemplateRemover } from './removeInspectionTemplate';
import { inspectionTemplateChecklistItemRemover } from './removeInspectionTemplateChecklistItem';
import { inspectionTemplateChecklistItemReorderer } from './reorderInspectionTemplateChecklistItem';
import { inspectionTemplateRestorer } from './restoreInspectionTemplate';

/**
 * Template and checklist item changes put on the HTTP queue; each resolves
 * once queued and its outcome follows as an event with the change's
 * `uniqueId`. One mapping for the channel server and the legacy handlers.
 */
export const queueInspectionTemplateChanges = {
  create: ({ inspectionTemplateOutDto, projectId, uniqueId }) =>
    inspectionTemplateCreator.execute(inspectionTemplateOutDto, projectId, uniqueId),
  edit: ({ templateId, inspectionTemplateOutDto, projectId, uniqueId }) =>
    inspectionTemplateEditor.execute(templateId, inspectionTemplateOutDto, projectId, uniqueId),
  remove: ({ templateId, projectId, uniqueId }) => inspectionTemplateRemover.execute(templateId, projectId, uniqueId),
  restore: (detail) => inspectionTemplateRestorer.execute(detail),
  createChecklistItems: ({ templateId, checklistItemsOutDto, projectId, uniqueId }) =>
    inspectionTemplateChecklistItemsCreator.execute(templateId, checklistItemsOutDto, projectId, uniqueId),
  editChecklistItem: ({ templateId, checklistItemId, checklistItemOutDto, projectId, uniqueId }) =>
    inspectionTemplateChecklistItemEditor.execute(templateId, checklistItemId, checklistItemOutDto, projectId, uniqueId),
  removeChecklistItem: ({ templateId, checklistItemId, projectId, uniqueId }) =>
    inspectionTemplateChecklistItemRemover.execute(templateId, checklistItemId, projectId, uniqueId),
  reorderChecklistItem: ({ templateId, checklistItemId, reorderDto, projectId, uniqueId }) =>
    inspectionTemplateChecklistItemReorderer.execute(templateId, checklistItemId, reorderDto, projectId, uniqueId),
} satisfies RequestHandlers<ContractShapeOf<typeof inspectionTemplateContract>>;
